import React from "react";
import useSaveNewPeriod from "../hooks/useSaveNewPeriod";
import Biscuit from '../../../../utils/Biscuit';
import {
  Error,
  SaveContainer
} from "../styled_components/styled_save_new/index";

import t from '../../../helpers/t';

const SaveNewPeriod = () => {

  const { clickHandler, message, cancelChanges } = useSaveNewPeriod();

  return (
    <>
      <Error>
        <span style={{ margin: "0 5px" }}>
          {message && message.length > 0 && (
            <i className="fi fi-alert"></i>
          )}
        </span>
        {message}
      </Error>
      <SaveContainer>
        <button
            className="button round hollow secondary"
            style={{marginRight:'5px'}}
            title={t('abort',null,'capital')}
            onClick={e => cancelChanges(e)}>
          <i
            className="fi fi-x"
            style={{paddingRight:'0'}}></i> 
          {/*<span>{t('abort',null,'capital')}</span>*/}
        </button>
        <button
            className={"button round beautify beautify-" + Biscuit.get('user.client_id')+ " expanded"}
            title={t('save',null,'capital')}
            onClick={e => clickHandler(e)}>
            <i className="fi fi-check"></i> 
            <span>
                {t('save',null,'capital')}
            </span>
        </button>
      </SaveContainer>
    </>
  );
};

export default SaveNewPeriod;
